import React,{ PureComponent  } from 'react'
import Dropdown from 'rc-dropdown'
import Menu, { Item as MenuItem } from 'rc-menu';
import { Link } from 'react-router-dom'
import config from '../../config/env'
import 'rc-dropdown/assets/index.css';
import './header.css'
class Header extends PureComponent {
    constructor(props){
        super(props);
        this.state = {
            current:0,
            consoleUrl:'http://democonsole.hit-cloud.net'
        }
    }
    componentWillReceiveProps(nextProps) {
        let path = nextProps.location.pathname;
        this.getCurrentRoute(path)
    }
    getCurrentRoute(path){
        let current = 0;
        if(path.includes('/list')){
            current=1
        }else if(path.includes('/case')){
            current=2
        }else if(path.includes('/about')){
            current=3
        }else{
            current = 0
        }
        this.setState({
            current
        })
        let origin = window.location.origin;
        if(origin === 'https://www.hit-cloud.cn'){
            this.setState({
                consoleUrl:'https://console.hit-cloud.cn'
            })
        }

        
    }
    componentDidMount(){
        const path =this.props.location.pathname
        this.getCurrentRoute(path)
    }
    render(){
        const { current,consoleUrl } = this.state
        const menuItems = [
            <MenuItem key="1">
                <Link to="/list/0">
                    <img src={config.baseUrl+"/hitcloud/home/index/icon-1.png"} />
                    电子宣传页
                </Link>
            </MenuItem>,
            <MenuItem key="2">
                <Link to="/list/1">
                    <img src={config.baseUrl+"/hitcloud/home/index/icon-2.png"} />
                    电子说明书
                </Link>
            </MenuItem>,
            <MenuItem key="3">
                <Link to="/list/2">
                    <img src={config.baseUrl+"/hitcloud/home/index/icon-3.png"} />
                    荣誉展示
                </Link>
            </MenuItem>,
            <MenuItem key="4">
                <Link to="/list/3">
                    <img src={config.baseUrl+"/hitcloud/home/index/icon-4.png"} />
                    问卷调查
                </Link>
            </MenuItem>,
            <MenuItem key="5">
                <Link to="/list/4">
                    <img src={config.baseUrl+"/hitcloud/home/index/icon-5.png"} />
                    行业报告
                </Link>
            </MenuItem>,
            <MenuItem key="6">
                <Link to="/list/5">
                    <img src={config.baseUrl+"/hitcloud/home/index/icon-6.png"} />
                    客服机器人
                </Link>
            </MenuItem>,
            <MenuItem key="7">
                <Link to="/list/6">
                    <img src={config.baseUrl+"/hitcloud/home/index/icon-7.png"} />
                    智慧网关
                </Link>
            </MenuItem>
        ];
        const menu = (
            <Menu className="dm-list">
                {menuItems}
                <i className="top"></i>
            </Menu>
        );
        return(
            <header>
                <div className='header-wrap'>
                    <div className="header-left">
                        <Link to="/">
                            <img className="logo"  src={config.baseUrl+"/hitcloud/home/index/logo.png"}/>
                        </Link>
                        <ul className="nav">
                            <Link to="/">
                                <li className={current==0 ? "nav-item active" : 'nav-item'}>
                                    首页 <i></i>
                                </li>
                            </Link>
                            <Dropdown overlay={menu}>
                                <li className={current==1 ? "nav-item active" : 'nav-item'}>  
                                    产品与服务 
                                    <i></i>
                                </li>
                            </Dropdown>
                            <Link to="/case">
                                <li className={ current==2 ? "nav-item active" : 'nav-item' }>
                                    合作案例 <i></i>
                                </li>
                            </Link>
                            <Link to="/about">
                                <li className={ current==3 ? "nav-item active" : 'nav-item' }>
                                    关于我们 <i></i>
                                </li>
                            </Link>
                        </ul>
                    </div>
                    <div className="header-right">
                        <span className="phone"></span>
                        <a href={consoleUrl} target="_blank" className="console">登录</a>
                    </div>
                </div>
            </header>
        )
    }
}

export default Header;